<template lang="html">
  <div class="menu">
    <div class="menu_content">
      <div class="menu_content_wrap">
        <div class="nav">
          <ul>
            <li>Shared Experience</li>
            <li>Future of Work</li>
            <li>Utility Service</li>
          </ul>
        </div>
        <div class="footer">
          <!--  TODO Remove link for ipad-->
          <a href="https://www.volkswagenag.com/">www.volkswagenag.com</a>
          <ul>
            <li class="social_link twitter"></li>
            <li class="social_link facebook"></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="menu_background" @click="switchMenu"></div>
  </div>
</template>

<script>

import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
import { masterBus } from '@/main.js';

export default {
  name: 'Menu',
  components:{},
  data(){
    return {
      menuOpened: false,
      animationRunning:false,
    }
  },
  mounted(){
    masterBus.$on('switchMenu', this.switchMenu);
  },
  methods:{
    switchMenu(){
      if(!this.animationRunning){
        this.animationRunning=true;
        if(this.menuOpened)this.closeMenu();
        else this.openMenu();
        this.menuOpened = !this.menuOpened;
      }
    },
    animationRunningReset(){
      this.animationRunning = false;
    },
    openMenu(){
      $('.hamburger-menu').addClass("animate");
      this.menuOpenTL = new TimelineLite({onComplete:this.animationRunningReset});
      this.menuOpenTL.to(".menu",.1,{autoAlpha:1})
                 .to(".menu_content",1,{ease:Expo.easeOut,transform: 'translateX(0)'})
                 .to(".menu_background",1,{ease:Expo.easeOut,opacity:1},"-=1")
                 .staggerTo(".nav li",.8,{ease:Expo.easeOut,transform:"translateX(0)",opacity:1,stagger:{amount:.3}},"-=1");
    },
    closeMenu(){
      $('.hamburger-menu').removeClass("animate");
      this.menuCloseTL = new TimelineLite({onComplete:this.animationRunningReset});
      this.menuCloseTL.to(".menu_content",1,{ease:Expo.easeOut,transform: 'translateX(-400px)'})
                 .to(".menu_background",1,{ease:Expo.easeOut,opacity:0},"-=1")
                 .to(".nav li",.2,{ease:Expo.easeOut,transform:"translateX(-40px)",opacity:0},"-=.2")
                 .to(".menu",.1,{autoAlpha:0},"-=.2");
    }
  }
}
</script>

<style lang="scss" scoped>
.menu{
  position: fixed;
  z-index: 9000;
  top:0;
  left:0;
  width: 100%;
  height: 100vh;
  visibility: hidden;
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
  .menu_content{
    position: absolute;
    z-index: 10;
    transform: translateX(-400px);
    left: 0;
    width: 400px;
    background: white;
    height: 100%;
    text-align: left;
    padding: 3rem;
    &_wrap{
      position: relative;
      height: 100%;
      width:100%;
      .nav{
        padding-top:60%;
        font-size: 1.8rem;
        li{
          opacity: 0;
          transform: translateX(-40px);
        }
      }
      .footer{
        position: absolute;
        bottom: 0;
        width:100%;
      }
    }
  }
  .menu_background{
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0,0,0,0.4);
    width: 100%;
    height: 100%;
    opacity: 0;
  }
}
</style>
